module.exports = __webpack_public_path__ + "static/media/SP_S_Timeless_Sforza_Bordeaux.62370a19.png";